import { useSearchParams } from "react-router-dom";

export const useConfigurationTab = (tabs: readonly string[]): [number, (index: number) => void] => {
  const [searchParams, setSearchParams] = useSearchParams();
  const selectedIndex = tabs.indexOf(searchParams.get("tab") ?? "");
  const selectTab = (index: number) => {
    const tab = tabs[index];
    if (!tab) return;
    const next = new URLSearchParams(searchParams);
    next.set("tab", tab);
    setSearchParams(next);
  };
  return [Math.max(0, selectedIndex), selectTab];
};
